import { useGetUser } from '@/modules/auth/service/auth'

export const useProfileData = () => {
  const { data, isLoading } = useGetUser()
  const profile = data?.data

  const permission =
    profile?.role?.permissions?.map((p) => p.key) ?? []

  const checkPermission = (ps: string) => {
    return permission.includes(ps)
  }

  return {
    profile: profile,
    isLoading,
    permission,
    checkPermission,
  }
}
